import React from 'react';
import cn from 'classnames';

import { Button } from '@lt/components';
import { isNil } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { i18n } from '@lt/localization';
import { touristSelector } from 'src/store/tourists/selectors';
import { pluralizeYears } from '../../utils/pluralizeUtils';
import { expandTouristFormAction } from '../../routes/Checkout/store/actions/view';
import { makeGetIsTouristFormActive } from '../../routes/Checkout/store/selectors/view';
import { TouristGender } from './Fields';
import TouristForm from '../../routes/Checkout/CheckoutRoutes/PackageCheckout/containers/Tourists/TouristForm';
import { makeGetIsTouristValidated } from '../../routes/Checkout/store/selectors/data';

const baseCls = 'tourists-form-collapsed';

class TouristFormMobile extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleExpand = this.handleExpand.bind(this);
  }

  handleExpand() {
    const { expandForm, index } = this.props;
    expandForm(index);
  }

  get genderColor() {
    const { touristData } = this.props;
    const { gender } = touristData || {};
    return TouristGender.ICONS[gender || 'NONE'].color;
  }

  renderEmptyData() {
    const { age } = this.props;

    const isAdult = isNil(age);

    return (
      <>
        <div>
          {isAdult
            ? i18n.t('checkout.touristForm.adult')
            : `${i18n.t('checkout.touristForm.child')}, ${age} ${pluralizeYears(
                age,
              )}`}
        </div>
        <div className="greylight">
          {i18n.t('checkout.touristForm.notFilled')}
        </div>
      </>
    );
  }

  renderTouristData() {
    const {
      touristData: { name, surname, passport_number, birthday },
      age,
    } = this.props;

    const isAdult = isNil(age);
    const stringAge = isAdult
      ? i18n.t('checkout.touristForm.adult')
      : `${i18n.t('checkout.touristForm.child')}, ${age} ${pluralizeYears(
          age,
        )}`;

    return (
      <>
        <div className="like-h4">{`${surname} ${name}, ${stringAge}`}</div>
        <div className="flex">
          <div className="blacklight">{passport_number}</div>
          <span className="blacklight divider-dot" />
          <div className="blacklight">{birthday}</div>
        </div>
      </>
    );
  }

  render() {
    const { isActive, isValidated, isEnabled } = this.props;
    return isActive ? (
      <TouristForm {...this.props} />
    ) : (
      <div className={cn(baseCls, { [`${baseCls}--validated`]: isValidated })}>
        <Button functional disabled={!isEnabled} onClick={this.handleExpand}>
          <div
            className="tourist_option__gender"
            style={{ backgroundColor: this.genderColor }}
          />
          <div>
            {isValidated ? this.renderTouristData() : this.renderEmptyData()}
          </div>
        </Button>
      </div>
    );
  }
}

TouristFormMobile.defaultProps = {
  age: null,
};
TouristFormMobile.propTypes = {
  index: PropTypes.number.isRequired,
  age: PropTypes.number,
};

const makeMapStateToProps = () => {
  const getIsTouristFormActive = makeGetIsTouristFormActive();
  const getIsTouristValidated = makeGetIsTouristValidated();

  return (state, props) => ({
    isActive: getIsTouristFormActive(state, props.index),
    isEnabled:
      props.index === 0 || getIsTouristValidated(state, props.index - 1),
    isValidated: getIsTouristValidated(state, props.index),
    touristData: touristSelector(state, props.index),
  });
};

const mapDispatchToProps = (dispatch) => ({
  expandForm: (index) => dispatch(expandTouristFormAction(index)),
});

export default connect(
  makeMapStateToProps,
  mapDispatchToProps,
)(TouristFormMobile);
